import { type Routes } from '@angular/router';
import { authGuard } from '@shared/auth.guard';
import { guestGuard } from '@shared/guest-guard';

export enum AppRoutes {
  LOGIN = 'login',
  SHUTTLE = 'shuttle',
  RESERVATION = 'reservation',
}

export const routes: Routes = [
  {
    path: '',
    redirectTo: AppRoutes.SHUTTLE,
    pathMatch: 'full',
  },
  {
    path: AppRoutes.LOGIN,
    canActivate: [guestGuard],
    loadComponent: () => import('./auth/login/login').then((m) => m.Login),
  },
  {
    path: AppRoutes.SHUTTLE,
    canActivate: [authGuard],
    loadChildren: () =>
      import('./shuttle/shuttle.routes').then((m) => m.routes),
  },
  {
    path: AppRoutes.RESERVATION,
    canActivate: [],
    loadChildren: () =>
      import('./reservation/reservation.routes').then((m) => m.routes),
  },
  {
    path: '**',
    redirectTo: AppRoutes.SHUTTLE,
    pathMatch: 'full',
  },
];
